<template>
  <div class="policy p_t">
    <TopHead title="新闻动态"></TopHead>
    <div class="l_out">
      <van-pull-refresh v-model="loading" @refresh="onRefresh">
        <van-list
          :immediate-check="false"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="list_out">
            <div class="items d_f ali_c cur_p" v-for="(item,index) in list" :key="index" @click="$router.push('/PolicyDetail?contentCode='+item.contentCode)">
              <van-image fit="cover" :src="item.coverUrl"/>
              <div class="flex_1">
                <div class="item_title">{{item.title}}</div>
                <div class="d_f ali_b j_s sub">
                  <span >{{item.createTime.split(' ')[0]}}</span>
                  <span>MORE+</span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Policy",
    data() {
      return {
        refreshing:false,
        loading:false,
        finished:false,
        list:[],
        params:{
          pageIndex:1,
          pageSize:10,
          columnCode:'',
        },
      }
    },
    created(){
      this.params.columnCode = this.$route.query.code;
      this.listContent();
    },
    methods: {
      listContent(){
        this.loading = true;
        this.$api.listContent(this.params).then(res => {

          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
          }
          if(res.data.recordCount){
            this.list = this.list.concat(JSON.parse(JSON.stringify(res.data.rows)));
          }
          let list = res.data.rows;
          if (!list || list.length < this.params.pageSize) {
            this.finished = true;
          }
        })
      },
      onRefresh(){
        this.list = [];
        this.finished = false;
        this.params.pageIndex = 1;
        this.listContent();
      },
      onLoad(){
        let me = this;
        if(me.loading) return
        let page = me.params.pageIndex;
        page = page ? page + 1 : 1;
        this.params.pageIndex = page;
        this.listContent();
      },
    }
  }
</script>

<style scoped lang="scss">
  .items{
    .sub{
      color: #333;
      font-size: 10px;
      font-weight: bold;
      span:last-child{
        color: #ff8039;
      }
    }
    .item_title{
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 22px;
    }
    .van-image{
      width: 120px;
      height: 79px;
      margin-right: 14px;
    }
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid #D7D7D7;
  }
  .l_out{
    .van-pull-refresh{
      height: 100%;
      overflow-y: auto;
    }
    height: 100%;
    padding: 18px 13px;
    box-sizing: border-box;
  }
</style>
